// Navbar.js
import React, { Component } from 'react';
import ActionSheet from '../modals/ActionSheet';
import ModalPortal from '../../../ModalPortal';
import filterIco from '../../../assets/icons/interface/filter.svg';
import searchIco from '../../../assets/icons/interface/search-navbar.svg';
import routeIco from '../../../assets/icons/interface/route.svg';
import FiltersCarousel from '../mainScreen/FiltersCarousel';
//import FullListComponent from '../modalsContent/FiltersComponent';
import RouteComponent from '../modalsContent/RouteComponent';
import SearchComponent from '../modalsContent/SearchComponent';
import FullListComponent from "../modalsContent/FullListComponent";

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSheet: false,
            sheetContent: null,
        };
    }

    openSheet = (content) => {
        this.setState({
            showSheet: true,
            sheetContent: content
        });
    };

    closeSheet = () => {
        this.setState({
            showSheet: false,
            sheetContent: null
        });
    };


    render() {

        const { showSheet, sheetContent } = this.state;
        const { searchContextValue, activeFiltersCount = 0 } = this.props; // Получаем значение контекста через props


        return (
            <footer className="navbar__wrapper">

                <div className="container footer-container">


                {/*<div className="rainbow-background">*/}
                {/*    <div className="gradient-runner">*/}
                {/*        <div className="gradient-item gradient-item--1"></div>*/}
                {/*        <div className="gradient-item gradient-item--2"></div>*/}
                {/*        <div className="gradient-item gradient-item--3"></div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                    <FiltersCarousel/>

                    <nav className="navbar__buttons">
                        <button
                            className="navbar__buttons-button"
                            onClick={() =>
                                this.openSheet((closeSheet) => (
                                    <FullListComponent
                                        onClose={closeSheet}
                                                       roadsData={searchContextValue?.roadsData}
                                                       setSelectedMarker={searchContextValue?.setSelectedMarker}
                                                       userPosition={searchContextValue?.userPosition}
                                    />
                                ))
                            }
                        >
                            <img src={filterIco} alt="Filter Icon"/>
                            <text>Заведения</text>
                        </button>

                        <button
                            className="navbar__buttons-button"
                            onClick={() =>
                                this.openSheet((closeSheet) => (
                                    <SearchComponent
                                        onClose={closeSheet}
                                        roadsData={searchContextValue?.roadsData}
                                        setSelectedMarker={searchContextValue?.setSelectedMarker}
                                        userPosition={searchContextValue?.userPosition}
                                    />
                                ))
                            }
                        >
                            <img src={searchIco} alt="Search Icon"/>
                            <text> Поиск</text>

                        </button>

                        <button
                            className="navbar__buttons-button small"
                            onClick={() =>
                                this.openSheet((closeSheet) => (
                                    <RouteComponent
                                        onClose={closeSheet}
                                        roadsData={searchContextValue?.roadsData}
                                        setSelectedMarker={searchContextValue?.setSelectedMarker}
                                        userPosition={searchContextValue?.userPosition}
                                    />
                                ))
                            }
                        >
                            <img src={routeIco} alt="Route Icon"/>
                            <text> Маршрут</text>
                        </button>

                        {/*<button*/}
                        {/*    className="navbar__buttons-button small"*/}
                        {/*    onClick={() =>*/}
                        {/*        this.openSheet((closeSheet) => (*/}
                        {/*            <RouteComponent*/}
                        {/*                onClose={closeSheet}*/}
                        {/*                roadsData={searchContextValue?.roadsData}*/}
                        {/*                setSelectedMarker={searchContextValue?.setSelectedMarker}*/}
                        {/*                userPosition={searchContextValue?.userPosition}*/}
                        {/*            />*/}
                        {/*        ))*/}
                        {/*    }*/}
                        {/*>*/}
                        {/*    <img src={routeIco} alt="Route Icon"/>*/}
                        {/*    <text> ???</text>*/}
                        {/*</button>*/}
                    </nav>


                {showSheet && (
                    <ModalPortal>
                        <ActionSheet
                            onCloseStart={() => {
                            }}
                            onCloseEnd={this.closeSheet}>
                            {sheetContent}
                        </ActionSheet>
                    </ModalPortal>
                )}
                </div>
            </footer>
        );
    }
}

export default Navbar;